import React, { JSX } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { useRecoilValue } from "recoil";
import * as Atom from "@/js/common/Atom";
import Util from "@/js/common/Util";
import Login from "@/js/portal/Login";
import TokenCheck from "./TokenCheck";
import Index from "@/js/portal/Index";
import LayoutTest from "@/js/portal/LayoutTest";
import FindPasswd from "../portal/FindPasswd";
import SystemMenu from "../system/common/SystemMenu";
import LeftMenu from "../system/common/LeftMenu";
import Header from "../system/common/Header";
import MbrJoinAply from "../portal/MbrJoinAply";
import Welcome from "../portal/Welcome";
import FindUser from "../portal/FindUser";

function Body() {
    const location = useLocation();
    // const isAdmin = useRecoilValue(Atom.isAdmin);
    const userInfo = useRecoilValue(Atom.userInfo);
    const menuList = [
        { url: "/portal/layout"     , el: <LayoutTest />  }, // 서비스소개
        { url: "/portal/index"      , el: <Index />       }, // INDEX
        { url: "/portal/login"      , el: <Login />       }, // 로그인
        { url: "/portal/findPasswd" , el: <FindPasswd />  }, // 비밀번호 찾기
        { url: "/portal/findUser"   , el: <FindUser />    }, // 아이디 찾기
        { url: "/portal/mbrJoinAply", el: <MbrJoinAply /> }, // 회원가입
        { url: "/portal/welcome/:userNm/:userId", el: <Welcome />}, // 회원가입 완료
    ];
    const rendering = () => {
        const resEls = [<Route key="index" path="/" element={<Index />} />]; // ROOT : 서비스소개
        if (Util.isNotEmpty(userInfo.userId)) {
            for (const menu of SystemMenu.menuList) {
                for (const subMenu of menu.subMenuList) {
                    menuList.push({ url: subMenu.url, el: subMenu.el }); // 대시보드
                    subMenu.detailMenuList?.forEach(detailMenu => {
                        menuList.push({ url: detailMenu.url, el: detailMenu.el });
                    })
                }
            }
        }
        interface menuProps {
            url: string;
            el: JSX.Element;
        }
        menuList.forEach((menuInfo: menuProps, idx: number) => {
            resEls.push(<Route key={idx} path={menuInfo.url} element={menuInfo.el} />);
        });
        return resEls;
    };

    return (
        <div className="w100p aiC usN">
            <TokenCheck />
            {location.pathname.startsWith("/system", 0) ?
                <div className="w100p dpFlx jcSb" style={{minHeight: "100vh", overflowY: "auto"}}>
                    <LeftMenu />
                    <div className="wc200" style={{paddingLeft: 50, paddingTop: 40, backgroundColor: "#f4f7f6"}}>
                        <div style={{width: 1250, minHeight: 787, paddingBottom: 92}}>
                            <Header/>
                            <Routes>
                                {rendering()}
                            </Routes>
                        </div>
                    </div>
                </div>
            : <Routes>{rendering()}</Routes>}
        </div>
    );
}
export default React.memo(Body);